import { render, staticRenderFns } from "./RootView.vue?vue&type=template&id=548bb528&lang=pug&"
import script from "./RootView.vue?vue&type=script&lang=ts&"
export * from "./RootView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports